export const en = {
  'ui2-tag': {
    tag: {
      defaultLabel: 'Tag'
    }
  }
};
